import * as React from 'react';
import clsx from 'clsx';

import './style.scss';

/* eslint-disable @typescript-eslint/indent, @typescript-eslint/brace-style */
export interface IOverlayFormInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>,
                                                    'onChange' | 'className'>
{
    variant?: 'underlined' | 'default';
    error?: string;
    hideErrorMessage?: boolean;
    onChange?: (value: string, original_event: React.ChangeEvent<HTMLInputElement>) => any;
    inputClassname?: string;
    wrapperClassname?: string;
}
/* eslint-enable @typescript-eslint/indent, @typescript-eslint/brace-style */


export const OverlayFormInput = React.forwardRef<HTMLInputElement, IOverlayFormInputProps>(
    ({
        inputClassname,
        wrapperClassname,
        placeholder,
        variant = 'default',
        error = false,
        hideErrorMessage = false,
        required,
        onFocus,
        onBlur,
        onChange,
        ...restInputProps
    }, ref) => {
        const [ inputInFocus, setInputInFocus ] = React.useState<boolean>(false);
        const hasError = !!error;

        return (
            <div
                className={clsx(wrapperClassname, 'overlay-form-input-wrapper', {
                    'underlined-variant': variant === 'underlined',
                    'default-variant': variant === 'default',
                    'has-error': hasError
                })}
            >
                <input
                    ref={ref}
                    className={clsx(inputClassname, 'overlay-form-input')}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        if (onChange) {
                            let { value } = event.currentTarget;
                            onChange(value, event);
                        }
                    }}
                    onFocus={(...args) => {
                        setInputInFocus(true);
                        if (onFocus) {
                            onFocus(...args);
                        }
                    }}
                    onBlur={(...args) => {
                        setInputInFocus(false);
                        if (onBlur) {
                            onBlur(...args);
                        }
                    }}
                    {...restInputProps}
                />
                {(placeholder && !inputInFocus && !restInputProps.value) && (
                    <div className="fake-placeholder">
                        <span className='main-placeholder-text'>{placeholder}</span>
                        {required && (
                            <span className='required-marker'>*</span>
                        )}
                    </div>
                )}
                {hasError && !hideErrorMessage && (
                    <div className="error-message">
                        {error}
                    </div>
                )}
            </div>
        );
    }
);
